<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13 8.00002L3 8M7.99998 3.00002L8.00002 13"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
